import { messageComponent } from '../../../components/message/message.component';
import ViewBase from '../../view-base.view';
import WorkTemplateAddEditView from './work-template-add-edit.view';
import WorkTemplateView from './work-templates.view';

export default function WorkTemplateMasterView() {
    ViewBase.call(this);
    let isListView = true;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";
    let inputDataModel = { masterId: "0", workType: "", iconList: [] };
    let _addClose = () => {
        isListView = true;
    }
    let _onSaveComplete = (result) => {
        isListView = true;
        isMsgOpen = true;
        showMsg = result[0].transStatus;
        msgTitle = this.getText(result[0].code);

    }
    let _onLoadDetailView = (masterId, workType, iconList) => {
        inputDataModel.masterId = masterId;
        inputDataModel.workType = workType;
        inputDataModel.iconList = iconList;
        isListView = false;
    }
    return {
        oninit: function (vnode) {

        },
        oncreate: function (vnode) {


        },
        onupdate: function (vnode) {
        },
        view: (vnode) => {
            return [
                isListView && m(WorkTemplateView, { onLoadDetailView: _onLoadDetailView }),
                !isListView && m(WorkTemplateAddEditView, { onAddClose: _addClose, onSaveComplete: _onSaveComplete, masterId: inputDataModel.masterId, workTypeList: inputDataModel.workType, iconList: inputDataModel.iconList }),
                m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: () => { isMsgOpen = false; } }),
                this.getBaseViews()
            ]
        }
    }
}
